import { PropsWithChildren } from "react";

interface ActionBarContentProps {}

export function ActionBarContent({
  children,
}: PropsWithChildren<ActionBarContentProps>) {
  return <div className="">{children}</div>;
}
